import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getManagementPositionList as getManagementPositionListApi,
	getManagementPosition as getManagementPositionApi,
	addNewManagementPosition as addNewManagementPositionApi,
	updateManagementPosition as updateManagementPositionApi,
	deleteManagementPosition as deleteManagementPositionApi,
	getOrganizationalChart as getOrganizationalChartApi
} from '../../helpers/establishment/backend_helper';

export const getManagementPositionList = createAsyncThunk('management_positions/getManagementPositionList', async () => {
	try {
		const response = getManagementPositionListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getManagementPosition = createAsyncThunk('management_positions/getManagementPosition', async management_position_id => {
	try {
		const response = getManagementPositionApi(management_position_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewManagementPosition = createAsyncThunk('management_positions/addNewManagementPosition', async management_position => {
	try {
		const response = addNewManagementPositionApi(management_position);
		toast.success('Departamento agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar management_position.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateManagementPosition = createAsyncThunk('management_positions/updateManagementPosition', async (management_position) => {
		try {
			const response = updateManagementPositionApi(management_position);
			toast.success('Departamento actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar management_position.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteManagementPosition = createAsyncThunk('management_positions/deleteManagementPosition', async management_position => {
	try {
		const response = await deleteManagementPositionApi(management_position);
		toast.success('Departamento eliminado exitosamente.', { autoClose: 3000 });
		return { management_position, ...response };
	} catch (error) {
		toast.error('Error al eliminar management_position.', { autoClose: 3000 });
		throw new Error(error);
	}
});



export const getOrganizationalChart = createAsyncThunk('management_positions/getOrganizationalChart', async () => {
	try {
		const response = getOrganizationalChartApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});
